
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Smartphone } from 'lucide-react';
import { useFirstLaunch } from '@/hooks/useFirstLaunch';
import { isCapacitor } from '@/lib/capacitor';

export function PWAInstallButton() {
  const [isClicked, setIsClicked] = useState(false);
  const { isMobile, isPWAInstalled } = useFirstLaunch();

  // Hide in native Capacitor apps
  if (isCapacitor()) return null;

  // Ne pas afficher si pas mobile ou déjà installé
  if (!isMobile || isPWAInstalled()) {
    return null;
  }

  // Ne pas afficher si définitivement rejeté
  const permanentlyDismissed = localStorage.getItem('pwa-permanently-dismissed');
  if (permanentlyDismissed) {
    return null;
  }

  const handleClick = () => {
    setIsClicked(true);
    
    // Déclencher l'événement personnalisé pour ouvrir le modal PWA
    window.dispatchEvent(new CustomEvent('pwa-install-requested'));
    
    // Reset après un délai
    setTimeout(() => setIsClicked(false), 2000);
  };

  return (
    <Button
      onClick={handleClick}
      variant="outline"
      size="sm"
      className={`fixed top-4 right-4 z-40 bg-white/90 backdrop-blur-sm border-primary/20 hover:bg-primary/5 transition-all duration-200 text-xs sm:text-sm ${
        isClicked ? 'scale-95' : ''
      }`}
    >
      <Smartphone className="h-3 w-3 sm:h-4 sm:w-4 mr-1 sm:mr-2" />
      <span className="hidden sm:inline">Installer</span>
      <span className="sm:hidden">App</span>
    </Button>
  );
}
